export const Constants = {
  canvasHeightOffset: 92,
  widthMSizePixels: 1024,
  maxLastStepForAttachments: 2147483646
};
